import React from 'react';
import { CheckoutInfo } from '../presentation/CheckoutInfo';
import { OrderSummary } from '../presentation/OrderSummary';


export const Checkout = () => {
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 h-full">
      <CheckoutInfo />
      <OrderSummary />
    </div>
  )
}